import { CommonModule, Location } from '@angular/common';
import { Component, computed, inject, input, output, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { IconSanitizerService, IdGeneratorPipe } from 'ngx-lib';

@Component({
    selector: 'app-section-header',
    templateUrl: './section-header.component.html',
    styleUrls: ['./section-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe]
})
export class SectionHeaderComponent {
    private readonly iconSanitizer = inject(IconSanitizerService);
    private readonly location = inject(Location);
    private readonly router = inject(Router);

    readonly title = input<string>();
    readonly subTitle = input<string>();
    readonly mainAdditionalTemplate = input<TemplateRef<unknown>>();
    readonly iconName = input<string>();
    readonly infoTemplate = input<TemplateRef<unknown>>();
    readonly actionsTemplate = input<TemplateRef<unknown>>();
    readonly isReadOnly = input(true);
    readonly titleStyle = input<'primary' | 'secondary' | 'tertiary'>('primary');
    readonly goBackAction = input<'default' | 'base' | 'custom'>('default');
    readonly sectionHeaderId = input<string>();

    readonly goBackActionChange = output<void>();

    readonly svg = computed(() => {
        const name = this.iconName();
        return name ? this.iconSanitizer.getIcon(name) : undefined;
    });

    readonly titleClasses = computed(() => ['title', this.titleStyle()].join(' '));

    async goBack(): Promise<void> {
        const action = this.goBackAction();

        if (action === 'base') {
            const currentPath = this.location.path();

            if (currentPath.length) {
                const baseUrl = currentPath.split('-');

                if (baseUrl.length) {
                    this.router.navigateByUrl(baseUrl[0]);
                }
            }
        }

        if (action === 'custom') {
            this.goBackActionChange.emit();
            return;
        }

        this.location.back();
    }
}
